import React, { useMemo, useEffect } from 'react'
import showdown from 'showdown'
import useReplaceLinkTarget from '../hooks/useReplaceLinkTarget'
const converter = new showdown.Converter()

const MarkdownHelperText = ({
  text,
}) => {

  const rootRef = useReplaceLinkTarget({
    html: text,
  })
  
  const allText = useMemo(() => {
    const lines = text instanceof Array ? text : [text]
    return lines
      .map(line => converter.makeHtml(line))
      .map(html => {
        const elem = document.createElement('div')
        elem.innerHTML = html
        const p = elem.querySelector('p')
        return p ? p.innerHTML : ''
      })
      .filter(l => l)
  }, [
    text,
  ])

  return (
    <span ref={ rootRef }>
      {
        allText.map((line, i) => {
          return (
            <React.Fragment key={ i } >
              <span dangerouslySetInnerHTML={{__html: line}}></span><br />
            </React.Fragment>
          )
        })
      }
    </span>
  )
}

export default MarkdownHelperText